import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormAssociadoPJ from './formAssociadoPJ';
import {
  addAssociadoAction,
  removeAssociadoAction,
  updateAssociadoAction
} from '../../store/associadoPJReducer/actions';

const mapStateToProps = (state, ownProps) => {
  const associado = state.associadoPJReducer
    .find((a) => a.tipoSocio === ownProps.tipoSocio && a.idSocio === ownProps.idSocio);
  const { navegations } = state.navegationStepsReducer;
  const dadosIniciaisPJReducer = state.dadosIniciaisPJReducer;
  const navigation = navegations.PessoaFisica.Produtos[0];
  const Grupos = [
    {
      IdEsteira: 0,
      Nome: "Associar cliente",
    },
    {
      ...navigation.Grupos.find((tela) => tela.Id === 1), // Dados Iniciais
      IdEsteira: 1,
    },
    {
      ...navigation.Grupos.find((tela) => tela.Id === 4), // Declarações Específicas
      IdEsteira: 2,
    },
    {
      ...navigation.Grupos.find((tela) => tela.Id === 7), // Documentos Anexos
      IdEsteira: 3,
    },
    {
      IdEsteira: 4,
      Nome: "Resumo",
      Campos: navigation.Grupos.flatMap((tela) => tela.Campos),
    },
    {
      IdEsteira: 5,
      Nome: "Conclusão",
    }
  ];

  return {
    associado,
    navigation: { ...navigation, Grupos },
    firstStep: Grupos[0],
    conclusaoStep: Grupos[Grupos.length - 1],
    CodigoGerente: dadosIniciaisPJReducer.formPJ.dadosIniciais_codigoGerente,
    camposResumo: Grupos.find((s) => s.IdEsteira === 4).Campos
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    addAssociadoAction,
    removeAssociadoAction,
    updateAssociadoAction
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormAssociadoPJ);
